<template>
  <div class="container">
    <div class="row py-4">
      <div class="col-12"><h1>{{title}}</h1></div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <iframe :src="url" :title="title"  />
      </div>
      <div class="col-sm-12 col-md-4">
        <ContactAddress />
      </div>
    </div>
    
  </div>
</template>

<script>
import ContactAddress from "../../components/molecules/ContactAddress.vue";
export default {
  name:"IframePage",    
  props:['url', 'title'],
  components:{
    ContactAddress,
  }
}
</script>

<style>
iframe {
  height: 100vh;
  width: 100%;
}
</style>